<div [ngClass]="emptyStateClass "class="se-empty-state--container">

  <se-icon name="{{ icon }}" size="950" [accent]="iconAccent" *ngIf="!isSubtle"></se-icon>

  <div class="se-empty-state__title" [textContent]="title"></div>

  <ng-content select="[se-cp-empty-state-description]"></ng-content>

  <a
    *ngIf="showLink"
    class="pl-button--highlight se-empty-state__button"
    [href]="actionUrl"
    target="{{ actionTarget || '' }}"
    (click)="doAction($event)">
    {{ actionLabel }}
  </a>

  <se-button
    class="se-empty-state__button"
    *ngIf="showButton"
    (click)="doAction($event)"
    se-data-emphasis="high"
    [se-data-value]="actionLabel">
  </se-button>

</div>
